import createAxios from '@framework/http';
import { services } from '../../utils/service';
import { ssoBaseUrl } from '../../utils/getSSOBaseUrl';

const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod', withCredentials: true });

/** 获取用户权限 */
export async function getUserPermitResource() {
    const result = await axios.get(`/rest/merchant/auth/getUserResources?platform=1`);
    return result;
}

/** 获取用户信息 */
export async function getAccountList() {
    const result = await axios.get(`/rest/merchant/account/queryAccountList`);
    return result;
}

/** 使用localSessionCode换商家信息 */
export async function getMerchantInfo(params: { sessionCode: string }) {
    const result = await axios.get(`/rest/merchant/account/queryMerchantBySessionCode`, params);
    return result;
}

/** 获取切换账号Token */
export async function getSwitchAccountToken(params: { sid: string }) {
    const result = await axios.post(`${ssoBaseUrl()}/pass/locallife/web/login/multiAccountChangeToken`, params);
    return result;
}

/** 切换账号接口 */
export async function multiAccountChangeLogin(params: {
    did: string;
    sid: string;
    multiUserToken: string;
    targetUserId: string;
}) {
    const result = await axios.post(`${ssoBaseUrl()}/pass/locallife/web/login/multiAccountChangeLogin`, params);
    return result;
}

/** 种登录态 */
export async function businessLogin(params: { authToken: string; sid: string }) {
    const result = await axios.get(services.login, {
        params,
    });
    return result;
}

/** 获取客服白名单 */
export async function getOpeningResult() {
    const result = await axios.get(services.getOpeningResult);
    return result;
}

/** 获取客服中心入口url */
export async function getFaqUrl(entranceId: number) {
    const result = await axios.get(`${services.getFaqUrl}?entranceId=${entranceId}`);
    return result;
}
